import React from 'react';
import { connectHits } from 'react-instantsearch-dom';

import { eventInfo, newsDate, pressReleaseInfo } from '../../articleHelper';
import { htmlForResult } from '../../search/searchHelper';
import { ArticleImage } from '../articleImage';
import { apiUrl } from '../../env';

const PageHits = ({ hits }) => {
  let pageHits = hits.map((hit) => ({
    ...hit,
    titleHtml: hit.title && hit._highlightResult.title.value,
    teaserHtml: hit.teaser && hit._highlightResult.teaser.value,
    contentHtml: hit.content && hit._highlightResult.content.value,
    urlHtml: hit._highlightResult.url.value.replace(apiUrl(window.location.hostname), ''),
    report: {
      news_date: hit.report_news_date
    },
    event: {
      event_date: hit.event_date,
      beginning: hit.event_beginning,
      event_city: hit.event_city,
      event_address: hit.event_address
    },
    pressrelease: {
      release_date: hit.pressrelease_release_date
    }
  }));

  return (
    <div className="ais-Hits">
      <ul className="ais-Hits-list">
        {pageHits.map((hit) => (
          <li key={hit.id} className="ais-Hits-item">
            <p className="no-margin">{newsDate(hit) || eventInfo(hit) || pressReleaseInfo(hit)}</p>
            <h2 className="margin-bottom-xs">
              <a
                href={hit.url}
                title={hit.title}
                dangerouslySetInnerHTML={{ __html: hit.titleHtml }}
              ></a>
            </h2>
            {!!hit.image_teaser_url && (
              <div className="hidden-desktop">
                <a href={hit.url} title={hit.title}>
                  <ArticleImage imageUrl={hit.image_teaser_url} imageAlt={hit.image_teaser_alt} />
                </a>
              </div>
            )}
            {!!htmlForResult(hit) && (
              <p dangerouslySetInnerHTML={{ __html: htmlForResult(hit) }}></p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

PageHits.propTypes = {
  hits: React.PropTypes.arrayOf(React.PropTypes.object)
};

PageHits.defaultProps = {
  hits: []
};

export default connectHits(PageHits);



// WEBPACK FOOTER //
// ./components/search/PageHits.js